import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { curve, translate } from '../config/anim';
import Header from './Header';
import { useHeader } from "../config/headerContext";

const anim = (variants) => {
    return {
        variants,
        initial: "initial",
        animate: "enter",
        exit: "exit"
    };
}

export default function PageLayout({ children }) {
    const { showHeader } = useHeader();

    const props = children.props.children.props;

    const [dimensions, setDimensions] = useState({
        width: null,
        height: null
    });

    useEffect(() => {
        function resize() {
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }
        resize();
        window.addEventListener("resize", resize);
        return () => {
            window.removeEventListener("resize", resize);
        };
    }, []);

    return (
        <>
            <div className={`${props.page ? "page curve " + props.page : "page curve"}`}>
                {showHeader && <Header />}
                {dimensions.width != null && <SVG {...dimensions} />}
                {children}
            </div>
        </>
    );
}

const SVG = ({ height, width }) => {
    const initialPath = `
        M0 300 
        Q${width / 2} 0 ${width} 300
        L${width} ${height + 300}
        Q${width / 2} ${height + 600} 0 ${height + 300}
        L0 0
    `;

    const targetPath = `
        M0 300
        Q${width / 2} 0 ${width} 300
        L${width} ${height}
        Q${width / 2} ${height} 0 ${height}
        L0 0
    `;

    return (
        <motion.svg className="transition-svg" {...anim(translate)}>
            <motion.path {...anim(curve(initialPath, targetPath))} />
        </motion.svg>
    );
}
